export function sortBy(initArray, attr) {
  // Clone so we can mutate in place
  const array = [...initArray];
  return array.sort((a, b) => (a[attr] <= b[attr] ? -1 : 1));
}
